// MyMapComponent.jsx

import React, { useEffect, useRef, useState } from 'react';
import './Way.css';

function MyMapComponent() {
  const ref = useRef();

  useEffect(() => {
    if (ref.current) {
      // Create the URL for the Google Maps Embed API with a marker
      const embedUrl = `https://www.google.com/maps/embed/v1/view?key=AIzaSyBLnDOy74i7bY90ErmQum7P9zFLaAVoY4g&center=49.284618,6.865870&zoom=17`;

      // Create an iframe element with the Google Maps Embed API URL
      const iframe = document.createElement('iframe');
      iframe.src = embedUrl;
      iframe.width = '100%';
      iframe.height = '600';
      iframe.frameBorder = '0';
      iframe.allowFullScreen = '';
      ref.current.appendChild(iframe);
    }
  }, []);

  return <div ref={ref} className="map" />;
}

export default MyMapComponent;
